import { CSV_ERROR_MESSAGE, CSV_SUCCESS_MESSAGE } from '@/constants';
import { Holiday } from '@/types/admin-holiday';
import useAppToast from '../useAppToast';
import { useCallback, useState } from 'react';

const exportHolidaysCsv = (data: Holiday[]) => {
  const BOM = '\uFEFF';
  const headers = ['ID', '休日名', '開始日', '終了日'];
  const rows = data.map(row =>
    [row.no, `"${row.holiday_name}"`, row.start_date, row.end_date].join(',')
  );
  const csvContent = [headers.join(','), ...rows].join('\n');

  const blob = new Blob([BOM + csvContent], { type: 'text/csv; charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `holiday${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const useAdminHolidayCSV = () => {
  const toast = useAppToast();
  const [csvLoading, setCsvLoading] = useState(false);

  const handleCsvDownload = useCallback(
    (data: Holiday[]) => {
      setCsvLoading(true);
      try {
        exportHolidaysCsv(data);
        toast.success(CSV_SUCCESS_MESSAGE);
      } catch {
        toast.error(CSV_ERROR_MESSAGE);
      } finally {
        setCsvLoading(false);
      }
    },
    [toast]
  );

  return { handleCsvDownload, csvLoading };
};
